// Extend if necessary
export const SPECIFIC_POSTAL_CODE_PATTERNS = [{ countryCode: 'PL', maskPattern: '##-###', rulePattern: /\d\d-\d\d\d/ }];
